import { Text } from '@checkatrade/web-ui';

export function TradeRating({
  score,
  count,
}: {
  score: number;
  count: number;
}) {
  return (
    <Text
      variant="bodySM"
      className="flex w-fit min-w-fit items-center gap-1 whitespace-nowrap rounded bg-accent-extraSoft px-2 py-0.5 font-semibold"
    >
      <span className="text-xl font-semibold text-secondary">
        <span className="sr-only">Review score</span>
        {score}
      </span>
      <span className="text-xs text-secondary">
        ({count} review
        {count === 1 ? '' : 's'})
      </span>
    </Text>
  );
}
